import React from 'react';
import { NavLink } from 'react-router-dom';
import { hasPermission } from '../../auth/authUtils';
import { bestContrast } from '../../../util/formatter';
import { useAppSelector } from '../../../hooks';

export interface LinkBadgeProps {
  url?: string;
  name?: string;
  title?: string;
  noLinkTitle?: string;
  colour?: string;
  permissionType?: string;
}
function LinkBadge({ url, name, title, noLinkTitle, colour, permissionType }: LinkBadgeProps) {
  const currentUser = useAppSelector((state) => state.auth);

  const _colour = colour || '#171717';
  const textClass = _colour
    ? bestContrast(_colour, 'text-light', 'text-dark')
    : 'text-light';

  let notClickable = () => (
    <div
      className={`badge me-2 ${textClass}`}
      style={{ backgroundColor: _colour }}
      title={noLinkTitle}
    >
      {name}
    </div>
  );

  let clickable = () => (
    <div
      className={`badge me-2 ${textClass}`}
      style={
        _colour === 'transparent'
          ? { border: 'solid 1px #545050', backgroundColor: _colour }
          : { backgroundColor: _colour }
      }
    >
      <NavLink to={url ?? '#'} title={title} className={`${textClass}`}>
        {name}
      </NavLink>
    </div>
  );

  return (
    <>
      {url && name
        ? hasPermission(currentUser, permissionType) && url
          ? clickable()
          : notClickable()
        : name
          ? notClickable()
          : '-'}
    </>
  );
}

export default LinkBadge;
